import React from 'react';
import { ConsoleLineChart } from '@alicloud/console-chart';

const data = [
  {
    name: '云产品A',
    data: [
      ['2018-04-01', 302335],
      ['2018-05-01', 402335],
      ['2018-06-01', 202335],
      ['2018-07-01', 502335],
      ['2018-08-01', 102335],
      ['2018-09-01', 602335],
      ['2018-10-01', 202335],
      ['2018-11-01', 402335],
    ],
  },
  {
    name: '云产品B',
    data: [
      ['2018-04-01', 33412],
      ['2018-05-01', 43412],
      ['2018-06-01', 23412],
      ['2018-07-01', 53412],
      ['2018-08-01', 13412],
      ['2018-09-01', 63412],
      ['2018-10-01', 23412],
      ['2018-11-01', 43412],
    ],
  },
  {
    name: '云产品C',
    data: [
      ['2018-04-01', 200001],
      ['2018-05-01', 600001],
      ['2018-06-01', 100001],
      ['2018-07-01', 500001],
      ['2018-08-01', 100001],
      ['2018-09-01', 900001],
      ['2018-10-01', 300001],
      ['2018-11-01', 900001],
    ],
  },
];

const config = {
  xAxis: {
    type: 'time',
    mask: 'YYYY-MM-DD',
  },
  yAxis: {
    min: 0,
  },
  smooth: true,
};

export default () => (
  <ConsoleLineChart data={data} config={config} height={300} />
);
